import { clsx } from 'clsx'
import { type FC } from 'react'

import { Picture } from '../../../../image'

import { useProductPageCarouselZoomableImageContext } from './ProductPageCarouselZoomableImageContext'
import { type ProductPageCarouselZoomableImageZoomedImageProps } from './ProductPageCarouselZoomableImageZoomedImageProps'

const MAX_IMAGE_WIDTH = 1000
/**
 * required for computing the image sizes but in this case it doesn't matter
 * as we are instructing the browser to always use the same image size
 */
const MIN_SCREEN_SIZE = 768

const ProductPageCarouselZoomableImageZoomedImage: FC<
  ProductPageCarouselZoomableImageZoomedImageProps
> = ({ alt, className }) => {
  const zoomableImageContext = useProductPageCarouselZoomableImageContext()

  return zoomableImageContext.zoomingIsActive ? (
    <div
      className={clsx(
        'absolute left-full top-0 z-10 size-full overflow-hidden border border-light-primary-low bg-light-primary-low',
        className,
      )}
      data-qa-id="product-zoomed-image"
      ref={zoomableImageContext.zoomedImageWrapperRef}
    >
      <Picture
        alt={alt}
        imageSizes={[[MIN_SCREEN_SIZE, MAX_IMAGE_WIDTH]]}
        ref={zoomableImageContext.zoomedImageRef}
        smallestImageSize={MAX_IMAGE_WIDTH}
        src={zoomableImageContext.zoomedImageSrc ?? ''}
        // eslint-disable-next-line react/forbid-component-props -- the rule was disabled before a comment became required
        style={{
          maxWidth: 'initial',
          position: 'absolute',
          transform: `translate(${-zoomableImageContext.translateValues
            .translateX}px, ${-zoomableImageContext.translateValues
            .translateY}px)`,
        }}
      />
    </div>
  ) : null
}

export { ProductPageCarouselZoomableImageZoomedImage }
